import * as React from "react";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../../Shared/Process/Process/ProcessComponent";
import { AssumedWrapCashHoldings } from "../../../../Common/PaymentsIn/AssumedWrapCashHoldings";
import { RegularPayment } from "../../../../Common/PaymentsIn/RegularPayment/RegularPayment";
import { SinglePayment } from "../../../../Common/PaymentsIn/SinglePayment/SinglePayment";
import { PaymentType, processTypeEnum } from "../../../../Common/Resource/Contents";
import { TransferIn } from "../../../../Common/PaymentsIn/TransferIn/TransferIn";
import { IsaAllowance } from "../../../../Common/ISA/PaymentsIn/IsaAllowance";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";
import { nbPaymentsInMessages } from "../../../../NewBusinessWizard/Resource/Contents";

interface IPaymentsInProps extends IProcessComponentProps {
    
}

interface IPaymentsInState {}

export class PaymentsIn extends ProcessComponent<IPaymentsInProps, IPaymentsInState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp, isReview } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            isReview: isReview,
        };
    };

    public isValid(): boolean {
        let isValid = super.isValid();
        isValid = isValid && this.atLeastOneContribution();
        if (!this.atLeastOneContribution()) {
            this.props.showErrorMsgPopUp([nbPaymentsInMessages.atLeastOneContribution]);
        }
        return isValid;
    }

    private atLeastOneContribution(): boolean {
        const { data } = this.props;

        return (
            data.ISAQuote?.ClientSinglePayment?.Money?.Amount > 0 ||
            data.ISAQuote?.ThirdPartySinglePayment?.Money?.Amount > 0 ||
            data.ISAQuote?.ClientRegularPayment?.Money?.Amount > 0 ||
            data.ISAQuote?.ThirdPartyRegularPayment?.Money?.Amount > 0 ||
            data.ISAQuote?.IsaTransfers?.length > 0
        );
    }

    public render(): JSX.Element {
        const { data, onChange } = this.props;
        return (
            <div>
                <h2>Payments in</h2>
                <SinglePayment
                    {...this.getProps("ISAQuote")}
                    clientInfo={this.props.data.ClientDetails}
                    checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                    subAccountType={SubAccountType.StocksIsa}
                    hasPaymentMethod={false}
                    processType={processTypeEnum.Quote}
                />
                <hr />
                <RegularPayment
                    {...this.getProps("ISAQuote")}
                    clientInfo={this.props.data.ClientDetails}
                    checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                    subAccountType={SubAccountType.StocksIsa}
                    hasContinue={true}
                    hasIndexation={false}
                    processType={processTypeEnum.Quote}
                />
                <hr />
                <TransferIn
                    isPost={false}
                    data={this.props.data.ISAQuote.IsaTransfers}
                    subAccountType={SubAccountType.StocksIsa}
                    jouneryType={processTypeEnum.Quote}
                    onChange={(changes) =>
                        this.onDataChange(
                            (changes) => this.onDataChange(onChange, changes, data, "ISAQuote"),
                            changes,
                            data.ISAQuote
                        )
                    }
                    isReview={this.props.isReview}
                    showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                    onRef={(ref) => this.appendChild(ref)}
                    accountServiceProposition={this.props.data.AccountServiceProposition}
                />
                <hr />
                {!data.SelectedProducts.some((ele) => SubAccountTypeHelper.isOnPlatformPension(ele.SubAccountType)) && (
                    <AssumedWrapCashHoldings {...this.getProps("AssumedHoldings")} />
                )}
                {this.props.data?.ISAQuote?.IsaAllowance && (
                    <IsaAllowance cssWrapper="mb-24 mt-38" {...this.getProps("ISAQuote")} />
                )}
            </div>
        );
    }
}
